import { render, staticRenderFns } from "./swatch.vue?vue&type=template&id=2dfe04c1&scoped=true&"
import script from "./swatch.vue?vue&type=script&lang=js&"
export * from "./swatch.vue?vue&type=script&lang=js&"
import style0 from "./swatch.vue?vue&type=style&index=0&id=2dfe04c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe04c1",
  null
  
)

export default component.exports